import axiosInstance from "./api";
import { getUserName } from "./auth";

const CACHE_VERSION = "v1";

export const EMPTY_PINS = { topics: [], personas: [], fragments: [] };

const cacheKey = (userName) => `pins:${CACHE_VERSION}:${userName}`;

const normalize = (raw) => ({
  topics: Array.isArray(raw?.topics)
    ? raw.topics.filter((v) => typeof v === "string")
    : [],
  personas: Array.isArray(raw?.personas)
    ? raw.personas.filter((v) => typeof v === "string")
    : [],
  fragments: Array.isArray(raw?.fragments)
    ? raw.fragments.filter((v) => typeof v === "string")
    : [],
});

export const readCache = (userName) => {
  try {
    return normalize(
      JSON.parse(localStorage.getItem(cacheKey(userName)) || "{}"),
    );
  } catch (_) {
    return EMPTY_PINS;
  }
};

const writeCache = (userName, pins) => {
  try {
    localStorage.setItem(cacheKey(userName), JSON.stringify(pins));
  } catch (_) {
    // Cache is optional; the server still holds the truth.
  }
};

// Every /pin/ response is the user's complete, normalised pin set, so each of the
// three calls below can just cache it directly.
const cacheAndReturn = async (pins) => {
  const userName = await getUserName();
  const normalized = normalize(pins);
  writeCache(userName, normalized);
  return normalized;
};

export const pinService = {
  getUserName,
  readCache,

  fetchAll: async () => {
    const result = await axiosInstance.get("/api/pin/");
    return cacheAndReturn(result?.data?.data);
  },

  pin: async (namespace, itemId) => {
    const result = await axiosInstance.post("/api/pin/", {
      namespace,
      item_id: itemId,
    });
    return cacheAndReturn(result?.data?.data);
  },

  unpin: async (namespace, itemId) => {
    const result = await axiosInstance.delete("/api/pin/", {
      params: { namespace, item_id: itemId },
    });
    return cacheAndReturn(result?.data?.data);
  },
};

export default pinService;
